/**
 * A margin percentage at headline size, for KPI tiles and summary cards.
 *
 * A margin is as much a headline as the revenue beside it, so it gets the
 * same size; a small pill next to a large dollar figure read as a footnote.
 * Colour sits on the number itself: red for a loss, otherwise the plain
 * foreground (no benchmark is agreed for these figures). Null -- zero revenue,
 * or nothing priced -- is a dash, never 0%: break-even is a different claim.
 * Size comes from the container, so the figure matches whatever it sits in.
 */
import { percent } from "@/lib/format";
import { cn } from "@/lib/utils";

export function MarginFigure({ value, className }: { value: number | null; className?: string }) {
  if (value === null || value === undefined) {
    return (
      <span
        className={cn("text-muted-foreground", className)}
        title="No revenue to measure a margin against"
      >
        —
      </span>
    );
  }
  return (
    <span className={cn("tabular-nums", value < 0 && "text-destructive", className)}>
      {percent(value)}
    </span>
  );
}
